module.exports = __webpack_public_path__ + "static/media/Thumbnail_S1129A.f3dd4485.png";